import "./App.css";
import Routeslist from "./Routeslist";

function App() {
  return (
    <div className="App">
      <Routeslist />
    </div>
  );
}

export default App;
